module.exports = __webpack_public_path__ + "img/t3-feature-text.48d02449.png";